import { SEPARATOR_STROKE, PALETTE, MQ_TABLET } from '../../../constants';
import { MediaQueryStyleSheet } from 'react-native-responsive';
import ResponsiveDimensionValues from '../../../components/common/responsive-dimension-values';

export default MediaQueryStyleSheet.create(
  {
    mainWrapper: {
      flex: 1,
    },
    content: {
      flex: 1,
      paddingHorizontal: 40,
      paddingBottom: 40,
    },
    changePassword: {
      flex: 1,
    },
    label: {
      paddingTop: 10,
    },
    password: {
      minHeight: 80,
    },
    confirmPassword: {
      minHeight: 36,
    },
    support: {
      flex: 0,
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    validationLabels: {
      marginBottom: 30,
    },
    validationLabel: {
      marginBottom: 5,
    },
    buttonStyle: {
    },
    backLink: {
      paddingTop: 12,
      minHeight: 52,
      width: 100,
    },
  },
  {
    [MQ_TABLET]: {
      mainWrapper: {
        flex: 1,
      },
      content: {
        width: ResponsiveDimensionValues.windowWidth * 0.6,
        alignSelf: 'center',
        borderWidth: 2,
        borderColor: PALETTE.primaryStrokeLine,
      },
      buttonStyle: {
        width: ResponsiveDimensionValues.windowWidth * 0.3,
        alignSelf: 'center',
      },
    },
  }
);
